import Vue from 'vue';

export default Vue.component('drops-loader', {
  template: require('./template.html'),
  name: 'drops-loader',
  props: {
    showLoader: {
      type: Boolean,
      required: true,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: 'tiny',
    },
    color: {
      type: String,
      required: false,
      default: 'green',
    },
    styles: {
      type: Object,
      require: false,
      default: () => ({}),
    },
  },
});



// WEBPACK FOOTER //
// ./src/mixins/components/drops-loader/index.js